<template>
  <div>
    <div class="cmi-loading-feedback" v-if="aniEventLoading">
      <span class="fa fa-spinner fa-spin fa-3x fa-fw"></span>
      <span>Loading upcoming events</span>
    </div>
    <div class="cmi-resource-view" v-if="showContent">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h3 class="header">UPCOMING EVENTS</h3>
          </div>
        </div>
        <div class="row">
          <transition-group
            name="animate-resource"
            enter-active-class="animated lightSpeedIn"
            leave-active-class="animated zoomOut"
          >
            <div
              v-for="item in eventItems"
              v-bind:key="item.pkey"
              v-bind:class="colClass"
            >
              <div class="widget cmi-widget">
                <div class="sermon-widget">
                  <div class="sermon-img">
                    <img v-bind:src="item.evt_EventPoster" alt="advert image" />
                  </div>
                  <div class="sermon-detail">
                    <p class="event-caption cmi-event-separator1">
                      {{ item.evt_EventCaption }}
                    </p>
                    <p class="event-detail cmi-event-separator1">
                      {{ item.evt_EventDetails }}
                    </p>

                    <p class="sermon-description">
                      <span class="sermon-title">Speaker: </span>
                      <span class="sermon-text">{{
                        item.evt_EventSpeaker
                      }}</span>
                    </p>
                    <p class="sermon-description">
                      <span class="sermon-title">Venue: </span
                      ><span class="sermon-text">
                        {{ item.evt_EventLocation }}</span
                      >
                    </p>
                    <p class="sermon-description">
                      <span class="sermon-title">Start date: </span
                      ><span class="sermon-text">{{
                        item.evt_EventStartDate
                      }}</span>
                    </p>
                    <p class="sermon-description">
                      <span class="sermon-title">End date: </span
                      ><span class="sermon-text">{{
                        item.evt_EventEndDate
                      }}</span>
                    </p>
                    <flip-countdown
                      :deadline="item.evt_EventStartDateISO"
                    ></flip-countdown>
                    <ul class="sermon-media">
                      <li>
                        <a
                          v-bind:href="item.evt_PosterDownloadLink"
                          title="download advert image"
                          ><i class="fa fa-download"></i
                        ></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </transition-group>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import FlipCountdown from "vue2-flip-countdown";
export default {
  components: {
    FlipCountdown
  },
  props: {
    baseUrl: { type: String }
  },
  data() {
    return {
      eventItems: [],
      aniEventLoading: false,
      colClass: "col-sm-6"
    };
  },
  methods: {
    getEventData: async function() {
      //debugger;
      this.aniEventLoading = true;
      let rData = null;
      let actionUrl = `${this.baseUrl}GetEventData`;
      try {
        ({ data: rData } = await axios.get(actionUrl));
      } catch (error) {
        this.aniEventLoading = false;
        throw error;
      }
      if (rData) {
        this.eventItems = rData;
        if (rData.length == 1) {
          this.colClass = "col-sm-12";
        } else {
          this.colClass = "col-sm-6";
        }
      }
      this.aniEventLoading = false;
    }
  },
  computed: {
    showContent: function() {
      if (this.eventItems.length > 0) {
        return true;
      }
      return false;
    }
  },
  async mounted() {
    await this.getEventData();
  }
};
</script>
